import { render, staticRenderFns } from "./PromoData.vue?vue&type=template&id=3bf3c67b"
import script from "./PromoData.vue?vue&type=script&lang=js"
export * from "./PromoData.vue?vue&type=script&lang=js"
import style0 from "./PromoData.vue?vue&type=style&index=0&id=3bf3c67b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports